import { SITE_CONFIG } from '../config/site-config';
import { icon } from './icons';

/* ---- Security overview PDF ---- */
export const securityPdfUrl = (): string =>
  SITE_CONFIG.SECURITY_PDF_URL || (SITE_CONFIG.ROUTING === 'path' ? '/assets/retax360-security-overview.pdf' : '');
export const securityPdfLink = (cls = 'btn btn-ghost'): string =>
  securityPdfUrl()
    ? `<a class="${cls}" href="${securityPdfUrl()}" target="_blank" rel="noopener" download>${icon('fileCheck')} Download the security overview (PDF)</a>`
    : '';
